import React from 'react';
import { ArrowRightIcon, MinusIcon, PlusIcon } from 'lucide-react';
import { buyerQuestions } from '../data/homepage';
export function QuestionsSection() {
  return <section aria-labelledby="questions-title" className="bg-mist" data-id="element-122" data-mp="2apg58at7e9sg">
      <div className="mx-auto grid max-w-[1280px] gap-8 px-5 py-12 md:px-8 md:py-16 lg:grid-cols-[minmax(0,4fr)_minmax(0,7fr)] lg:gap-16" data-id="element-123" data-mp="25qliixs48132">
        <div data-id="element-124" data-mp="1wr84drt1qoc0">
          <h2 id="questions-title" className="max-w-[620px] text-[30px] font-extrabold leading-[1.12] text-ink md:text-[42px] lg:max-w-[420px]" data-id="element-125" data-mp="1ws03hclur471">
            Questions about working with WebsiteForge?
          </h2>
          <p className="mt-5 max-w-[640px] text-[17px] leading-[1.6] text-ink/80 lg:max-w-[380px]" data-id="element-126" data-mp="1n281hxbfb8sj">
            You bring the business goals. We help you work out the right mix of
            website, marketing, and automation, with clear scope and ongoing support.
          </p>
          <a href="#contact" className="mt-5 inline-flex min-h-11 items-center gap-2 text-[16px] font-bold text-ink underline decoration-brand-orange decoration-2 underline-offset-[6px] hover:decoration-ink" data-id="element-127" data-mp="192yot7mfewtb">
            Ask us about your project
            <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden data-id="element-128" data-mp="hq59wo4acfru" />
          </a>
        </div>
        <div className="min-w-0 border-t border-mist-line" data-id="element-129" data-mp="lqxgtapoq8ky">
          {buyerQuestions.map((item, index) => <details key={item.q} open={index === 0} className="group border-b border-mist-line" data-id="element-130" data-mp="19gjhk2lpgvv2" data-mpi={index}>
              <summary className="flex min-h-16 cursor-pointer list-none items-start justify-between gap-5 py-5 text-[18px] font-bold leading-snug text-ink hover:text-brand-greenDeep [&::-webkit-details-marker]:hidden" data-id="element-131" data-mp="1eg4hogcm3a9d">
                <span data-id="element-132" data-mp="15dv75qhcfgvz">{item.q}</span>
                <span className="mt-0.5 shrink-0 text-brand-greenDeep" aria-hidden data-id="element-133" data-mp="15h0xta5meqtt">
                  <PlusIcon className="h-5 w-5 group-open:hidden" strokeWidth={2} data-id="element-134" data-mp="3l50y3xjw7gto" />
                  <MinusIcon className="hidden h-5 w-5 group-open:block" strokeWidth={2} data-id="element-135" data-mp="3q703fcz70nt9" />
                </span>
              </summary>
              <p className="max-w-[640px] pb-5 pr-2 text-[16px] leading-[1.6] text-ink/80 sm:pr-10" data-id="element-136" data-mp="1vr1fs2qaibw7">
                {item.a}
              </p>
            </details>)}
        </div>
      </div>
    </section>;
}